import * as api from "./client";

export type LegacyPublication = {
  id: number;
  publication: string;
  edition: string;
  publicationStatus?: string;
  publicationFromDate?: string;
  publicationToDate?: string;
  previousEditionId?: number | null;
};

export type LegacyPublicationsResponse = {
  publications: LegacyPublication[];
  pagination?: {
    total?: number;
    limit?: number;
    offset?: number;
    hasMore?: boolean;
  };
};

function buildEndpoint(edition?: string, limit?: number, offset?: number, status?: string): string {
  const searchParams = new URLSearchParams();
  if (edition) {
    searchParams.append("edition", edition);
  }
  if (status) {
    searchParams.append("status", status);
  }
  if (limit !== undefined) {
    searchParams.append("limit", String(limit));
  }
  if (offset !== undefined) {
    searchParams.append("offset", String(offset));
  }
  const query = searchParams.toString();
  return `/v1/taxonomy/legacy-publications${query ? `?${query}` : ""}`;
}

async function fetchAllLegacyPublications(
  edition?: string,
  status?: string,
): Promise<LegacyPublicationsResponse> {
  const first = await api.get<LegacyPublicationsResponse>(
    buildEndpoint(edition, undefined, undefined, status),
  );
  const all = [...first.publications];

  const pageLimit = first.pagination?.limit ?? 50;
  let hasMore = first.pagination?.hasMore ?? false;
  let offset = pageLimit;

  while (hasMore) {
    const page = await api.get<LegacyPublicationsResponse>(
      buildEndpoint(edition, pageLimit, offset, status),
    );
    all.push(...page.publications);
    hasMore = page.pagination?.hasMore ?? false;
    offset += pageLimit;
  }

  return { ...first, publications: all };
}

export async function getLegacyPublications(
  params: { edition?: string; limit?: number; status?: string } = {},
) {
  if (params.limit !== undefined) {
    return api.get<LegacyPublicationsResponse>(
      buildEndpoint(params.edition, params.limit, undefined, params.status),
    );
  }

  return fetchAllLegacyPublications(params.edition, params.status);
}
